import React, { useRef, useEffect, useState } from "react";
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import LiquidacionSelect from "../../../components/select/LiquidacionSelect";

export default function FiltroFacturacionClientesPorLiquidacion({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const adaptNombre = (e) => (e ? { ...e, label: e.nombre } : null);

  const filtroRef = useRef(null);

  // ============================
  //        ESTADOS (rehidratables)
  // ============================

  const [cliente, setCliente] = useState(
    adaptNombre(initialFilters.cliente) ?? null
  );

  const [liquidacion, setLiquidacion] = useState(
    initialFilters.liquidacion ?? null
  );

  // ============================
  //   CERRAR CLICK FUERA / ESC
  // ============================
  useEffect(() => {
    const outside = (event) => {
      if (filtroRef.current && !filtroRef.current.contains(event.target)) {
        onClose();
      }
    };

    const esc = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // ============================
  //        SUBMIT
  // ============================
  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit({
      cliente,
      liquidacion,

      // 🔥 solo IDs al backend
      clienteId: cliente?.id ?? null,
      liquidacionId: liquidacion?.id ?? null,
    });
  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          
          {/* Cliente */}
          <div>
            <label className="form-label-fil">Cliente</label>
            <ClienteAutocomplete
              value={cliente}
              onChange={(e) => setCliente(adaptNombre(e))}
              placeholder="Buscar Cliente..."
            />
          </div>

          {/* Liquidación */}
          <div>
            <label className="form-label-fil">Liquidación</label>
            <LiquidacionSelect
              value={liquidacion}
              onChange={setLiquidacion}
              autoLoad
            />
          </div>

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
